export const PROFILES_REDUCER_NAME = 'profiles'
export const PROFILES_LIST_REDUCER_NAME = 'profilesList'
export const DELETE_PROFILE_REDUCER_NAME = 'deleteProfile'

export enum PROFILES_HEADERS {
  ID = 'id',
  NAME = 'name',
  THUMBNAIL = 'thumbnail',
  MANUFACTURER = 'manufacturer',
  MODEL = 'model',
  DEVICE_CLASS = 'deviceClass',
  UPLOADED = 'uploaded',
  VERSION = 'version',
  DOWNLOAD_LINK = 'downloadLink',
}
